import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter Options")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Channel Ref ID", -1)
const _hoisted_7 = { class: "row g-9 mb-5" }
const _hoisted_8 = { class: "col-md-6 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Type", -1)
const _hoisted_10 = { class: "col-md-6 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Status", -1)
const _hoisted_12 = { class: "mb-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Institution Name", -1)
const _hoisted_14 = { class: "row g-9 mb-5" }
const _hoisted_15 = { class: "col-md-6 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "BCN", -1)
const _hoisted_17 = { class: "col-md-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "VA Number", -1)
const _hoisted_19 = {
  key: 0,
  class: "row g-9 mb-5"
}
const _hoisted_20 = { class: "col-md-6 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Channel", -1)
const _hoisted_22 = { class: "col-md-6 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Terminal", -1)
const _hoisted_24 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Gateway", -1)
const _hoisted_26 = { class: "row g-9 mb-5" }
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Elapsed TIme "),
  /*#__PURE__*/_createVNode("i", null, "(Second)")
], -1)
const _hoisted_29 = { class: "col-md-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, " ", -1)
const _hoisted_31 = { class: "mb-5" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Transaction Date", -1)
const _hoisted_33 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_scrollbar, { "max-height": "380px" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_el_row, {
            class: "d-flex justify-content-between",
            gutter: 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { sm: 12 }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("div", null, [
                      _createVNode(_component_el_input, {
                        size: "small",
                        modelValue: _ctx.data.ref_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.ref_id = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode("div", null, [
                        _createVNode(_component_el_select, {
                          size: "small",
                          modelValue: _ctx.data.type,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.type = $event)),
                          placeholder: "Please select type",
                          style: {"width":"100%"},
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invocationType, (value, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: value,
                                value: key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("div", null, [
                        _createVNode(_component_el_select, {
                          size: "small",
                          modelValue: _ctx.data.status,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.status = $event)),
                          placeholder: "Please select status",
                          style: {"width":"100%"},
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invocationStatus, (value, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: value,
                                value: key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("div", null, [
                      _createVNode(_component_el_input, {
                        size: "small",
                        modelValue: _ctx.data.institution,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.institution = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          size: "small",
                          modelValue: _ctx.data.bcn,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.bcn = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          size: "small",
                          modelValue: _ctx.data.va_number,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.data.va_number = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { sm: 12 }, {
                default: _withCtx(() => [
                  (_ctx.checkRole(['sysadmin',
              'operational',
              'implementator',
              'reconcile',
              'finance']).isGranted)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode("div", null, [
                            _createVNode(_component_el_select, {
                              size: "small",
                              modelValue: _ctx.data.channel,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.data.channel = $event)),
                              placeholder: "Please select channel",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "all",
                                  value: ""
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channel, (value, key) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: key,
                                    label: value,
                                    value: key
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("div", null, [
                            _createVNode(_component_el_select, {
                              size: "small",
                              modelValue: _ctx.data.payment_terminal,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.data.payment_terminal = $event)),
                              placeholder: "Please select payment terminal",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "all",
                                  value: ""
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentTerminal, (value, key) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: key,
                                    label: value,
                                    value: key
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.checkRole(['sysadmin',
              'operational',
              'implementator',
              'reconcile',
              'finance']).isGranted)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("div", null, [
                          _createVNode(_component_el_select, {
                            size: "small",
                            modelValue: _ctx.data.gateway,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.data.gateway = $event)),
                            placeholder: "Please select gateway",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "all",
                                value: ""
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gateway, (value, key) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: key,
                                  label: value,
                                  value: key
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode("div", null, [
                        _createVNode(_component_el_select, {
                          size: "small",
                          modelValue: _ctx.data.condition,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.data.condition = $event)),
                          placeholder: "Please select condition"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "all",
                              value: ""
                            }),
                            _createVNode(_component_el_option, {
                              label: "Equal",
                              value: "="
                            }),
                            _createVNode(_component_el_option, {
                              label: "Lower",
                              value: "<"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Lower and Equal",
                              value: "<="
                            }),
                            _createVNode(_component_el_option, {
                              label: "Greater",
                              value: ">"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Greater and Equal",
                              value: ">="
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          size: "small",
                          modelValue: _ctx.data.elapsed_time,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.data.elapsed_time = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("div", null, [
                      _createVNode(_component_el_date_picker, {
                        size: "small",
                        modelValue: _ctx.data.date,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.data.date = $event)),
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "Start date",
                        "end-placeholder": "End date",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_33, [
            _createVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-white btn-active-light-primary me-2",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, " Reset "),
            _createVNode("button", {
              type: "submit",
              class: "btn btn-sm btn-primary",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args)))
            }, " Apply ")
          ])
        ])
      ]),
      _: 1
    })
  ]))
}